import React, { useState } from 'react'
import imagePlus from "../../../img/MyNextId/showcase-plus.png";
import imageMinus from "../../../img/MyNextId/showcase-minus.png";
import ShowcaseBoxLink from './ShowcaseBoxLink';

const ShowcaseBox = (props:any) => {
    const val = props.data;

    const [isOpen, setIsOpen] = useState(false);

    return (

        <div className="grid-container">
            <div  className='showcase-element'>
                <div className={isOpen ? "top top2 " : "top"} style={{backgroundColor:`${isOpen ? `#343c6d` : val.color}`}}>
                    {isOpen ? <>
                        <div className='showcase-top2'>
                            <img className="showcase-image" src={isOpen ? imageMinus : imagePlus} alt = "" onClick={()=> {setIsOpen(!isOpen)}}></img>
                            <h2 className='showcase-el-mini' style={{color:val.color}}>{val.title}</h2>
                        </div>
                        
                        <p>{val.desc}</p>
                        {val.examples.map((val2:any, key2:any) => {
                            return (
                                <p key={"example-"+key2} className="showcase-examples" >{val2}</p>
                            )   
                        })}
                    </>:<>
                        <img className="showcase-image" src={isOpen ? imageMinus : imagePlus} alt="showcase-image" onClick={()=> {setIsOpen(!isOpen)}}></img>
                        <h2 className='showcase-el-title'>{val.title}</h2>
                    </>}
                    
                </div>

                {val.details.map((val2:any, key2:any) => {
                    return (
                        <ShowcaseBoxLink key={"el-"+key2} index={key2} color={val.color} {...val2}/>
                    )   
                })}
            </div>
        </div>

    )
}

export default ShowcaseBox

/* OLD WAY - REFRENCE  */
{/*<div className="grid-container">
            <div  className='showcase-element'>
                <div className={isOpen ? "top top2 " : "top"} style={{backgroundColor:`${isOpen ? `#343c6d` : val.color}`}}>
                    {isOpen ? <>
                        <div className='showcase-top2'>
                            <img className="showcase-image" src={isOpen ? imageMinus : imagePlus} alt = "" onClick={()=> {setIsOpen(!isOpen)}}></img>
                            <h2 className='showcase-el-mini' style={{color:val.color}}>{val.title}</h2>
                        </div>
                        
                        <p>{val.desc}</p>
                        {val.examples.map((val2:any, key2:any) => {
                            return (
                                <p key={"example-"+key2} className="showcase-examples" >{val2}</p>
                            )   
                        })}
                    </>:<>
                        <img className="showcase-image" src={isOpen ? imageMinus : imagePlus} alt = "" onClick={()=> {setIsOpen(!isOpen)}}></img>
                        <h2 className='showcase-el-title'>{val.title}</h2>
                    </>}
                    
                </div>

                {val.details.map((val2:any, key2:any) => {
                    return (
                        <ShowcaseBoxLink key={"el-"+key2} index={key2} color={val.color} {...val2}/>
                    )   
                })}
            </div>
            </div>*/}